import React, { useState } from "react";
import { ModalBody, Modal } from "reactstrap";
import styles from "./contactsupportmodal.module.scss";
import Proptypes from "prop-types";
import Textfield from "../Shared/Textfield";
import Button from "../Shared/Button";
import { useFormik } from "formik";
import * as yup from "yup";
import { toast } from "react-toastify";
import { contactSupport } from "../../helpers";
import BlueTick from "../../assets/images/checkmark-circle-01.png";
import WarningIcon from "../../assets/images/warning-icon.svg";
import { useSelector } from "react-redux";
import CuteMascotSpinner from "../../global/CuteMascotSpinner";

const ContactSupportSchema = yup.object().shape({
  subject: yup.string().required("Required"),
  message: yup.string().required("Required"),
});

const ContactSupportModal = ({ openModal, toggle }) => {
  const { idToken } = useSelector((state) => state?.authReducer);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const formik = useFormik({
    initialValues: {
      subject: "",
      message: "",
    },
    validationSchema: ContactSupportSchema,
    onSubmit: (values) => {
      handleSubmitContactSupport(values);
    },
  });

  const handleSubmitContactSupport = async (values) => {
    try {
      setLoading(true);
      await contactSupport(values, idToken);
      formik.setSubmitting(false);
      setLoading(false);
      toast.success("Message sent successfully!");
      setSuccess(true);
      setError(false);
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "";
      toast.error(
        errorMessage ? errorMessage : "Something went wrong. Please try again."
      );
      formik.setSubmitting(false);
      toast.error("Something went wrong. Please try again.");
      setSuccess(false);
      setError(true);
    }
  };
  return (
    <>
      {loading && <CuteMascotSpinner />}
      <Modal
        isOpen={openModal}
        toggle={() => {
          toggle();
        }}
        centered
        fullscreen="sm"
        contentClassName={styles["modal_content"]}
        className={styles["container"]}
        wrapClassName={styles["modal_wrapper"]}
      >
        <ModalBody className={styles["modal_body"]}>
          {success ? (
            <div className={styles["error_success_container"]}>
              <img alt="success" src={BlueTick} width={102} height={102} />
              <div className={styles["success_heading"]}>Message sent</div>
              <div className={styles["success_label"]}>
                We got your message and will respond as soon as we can. Watch
                your email for help from Lumi.
              </div>
              <div>
                <Button
                  className={styles["okay_btn"]}
                  text="Okay"
                  onClick={toggle}
                />
              </div>
            </div>
          ) : error ? (
            <>
              <div className={styles["error_success_container"]}>
                <div>
                  <img
                    alt="success"
                    src={WarningIcon}
                    width={102}
                    height={102}
                  />
                </div>
                <div className={styles["error_label"]}>
                  Something went wrong. Please wait a moment and try again.
                </div>
                <div>
                  <Button
                    className={styles["okay_btn"]}
                    text="Okay"
                    onClick={toggle}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              {" "}
              <div className={styles["header"]}>Contact support</div>
              <div className={styles["label"]}>
                Write your email to the Lumi team. We will get back to you as
                soon as we can.
              </div>
              <div className={styles["input_container"]}>
                <Textfield
                  value={formik.values.subject}
                  error={formik.errors.subject}
                  touched={formik.touched.subject}
                  handleBlur={formik.handleBlur}
                  name="subject"
                  id="subject"
                  onChange={formik.handleChange}
                  type="text"
                  placeholder="Subject"
                  className={`${styles["input_field_styles"]}`}
                  disabled={formik.isSubmitting}
                />
              </div>
              <div className={styles["input_container"]}>
                <Textfield
                  value={formik.values.message}
                  error={formik.errors.message}
                  touched={formik.touched.message}
                  handleBlur={formik.handleBlur}
                  type="textarea"
                  placeholder="Message"
                  className={`${styles["input_field_styles"]} ${styles["text_area_styles"]}`}
                  onChange={formik.handleChange}
                  name="message"
                  id="message"
                  disabled={formik.isSubmitting}
                />
              </div>
              <div className={styles["submit_btns"]}>
                <div className={styles["button_div"]}>
                  <Button
                    className={styles["button_style_cancel"]}
                    onClick={() => {
                      toggle();
                    }}
                    text="Cancel"
                  />
                </div>
                <div className={styles["button_div"]}>
                  <Button
                    className={styles["button_style_add"]}
                    onClick={() => {
                      formik.submitForm();
                    }}
                    text="Send"
                    disabled={formik.isSubmitting}
                  />
                </div>
              </div>
            </>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

ContactSupportModal.propTypes = {
  openModal: Proptypes.bool,
  toggle: Proptypes.func,
};

export default ContactSupportModal;
